/** @format */
import { DOCUMENT, Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NavigationService {
    constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

    /**
     * Returns a string containing the Unicode serialization of the origin of the current location's URL.
     */
    get locationOrigin(): string {
        return this._document.location.origin;
    }

    /**
     * Causes the window to load and display the document at the URL specified.
     * After the navigation occurs, the user can navigate back to the page, that called this method, by pressing the "back" button.
     */
    navigate(url: string): void {
        this._document.location.assign(url);
    }
}
